import { Box } from '@mui/material';
import { FeaturesSection } from './components/FeaturesSection';
import { HeroSection } from './components/HeroSection';
import { LinksSection } from './components/LinksSection';
import { SocialLinks } from './components/SocialLinks';
import { VideoBackground } from './components/VideoBackground';

const Home = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <VideoBackground />
      <HeroSection />
      <FeaturesSection />
      <LinksSection />
      <SocialLinks />
    </Box>
  );
};

export default Home;
